import { NavigationStrategy } from "@aurelia/router";

// A navigation strategy defers the import until the route is visited. Given a plain import(), the router
// imports every route up front, and with them the stylesheets they carry.
export default [
  {
    path: "",
    component: new NavigationStrategy(() => import("./routes/index")),
    data: { title: "pageTitle.start", name: "start", public: true, hideNav: true },
  },
  {
    path: "account/bad-activation-link",
    component: new NavigationStrategy(() => import("./routes/account/bad-activation-link")),
    data: { title: "pageTitle.badActivationLink", public: true },
  },
  // Not ":customer": sharing that parameter with the routes below makes the route recognizer split
  // "demo/applications" into two matches, so the customer's start page has a name of its own.
  {
    path: ":shortName",
    component: new NavigationStrategy(() => import("./routes/application/index")),
    data: { title: "pageTitle.customerStart", public: true },
  },
  {
    path: ":customer/applications",
    component: new NavigationStrategy(() => import("./routes/application/applications")),
    data: { title: "pageTitle.applications" },
  },
  {
    path: ":customer/applications/:id",
    component: new NavigationStrategy(() => import("./routes/application/edit")),
    data: { title: "pageTitle.application", hideNav: true },
  },
  {
    path: ":customer/applications/:id/submit",
    component: new NavigationStrategy(() => import("./routes/application/submit")),
    data: { title: "pageTitle.submitApplication", hideNav: true },
  },
  {
    path: ":customer/applications/:id/submitted",
    component: new NavigationStrategy(() => import("./routes/application/submit-success")),
    data: { title: "pageTitle.applicationSubmitted", hideNav: true },
  },
  {
    path: ":customer/applications/:id/sign/confirm",
    component: new NavigationStrategy(() => import("./routes/application/sign/confirm")),
    data: { title: "pageTitle.confirmSignature", hideNav: false },
  },
  {
    path: ":customer/applications/:id/sign/reject",
    component: new NavigationStrategy(() => import("./routes/application/sign/reject")),
    data: { title: "pageTitle.rejectSignature", hideNav: false },
  },
  {
    path: ":customer/applications/:id/print",
    component: new NavigationStrategy(() => import("./routes/application/print")),
    data: { title: "pageTitle.printApplication", name: "print", public: true, hideNav: true },
  },
  {
    path: ":customer/reports/:id",
    component: new NavigationStrategy(() => import("./routes/report/edit")),
    data: { title: "pageTitle.report", hideNav: true },
  },
  {
    path: ":customer/applications/:id/requisitions",
    component: new NavigationStrategy(() => import("./routes/requisition/overview")),
    data: { title: "pageTitle.requisitions" },
  },
  {
    path: ":customer/applications/:applicationId/requisitions/:requisitionId",
    component: new NavigationStrategy(() => import("./routes/requisition/edit")),
    data: { title: "pageTitle.requisition", hideNav: true },
  },
  {
    path: ":customer/applications/:applicationId/requisitions/:requisitionId/submit",
    component: new NavigationStrategy(() => import("./routes/requisition/submit")),
    data: { title: "pageTitle.submitRequisition", hideNav: true },
  },
  {
    path: ":customer/requisitions/:id/submitted",
    component: new NavigationStrategy(() => import("./routes/requisition/submit-success")),
    data: { title: "pageTitle.requisitionSubmitted", hideNav: true },
  },
  {
    path: ":customer/requisitions/:id/print",
    component: new NavigationStrategy(() => import("./routes/requisition/print")),
    data: { title: "pageTitle.printRequisition", name: "print", public: true, hideNav: true },
  },
  {
    path: ":customer/reports/:id/submit",
    component: new NavigationStrategy(() => import("./routes/report/submit")),
    data: { title: "pageTitle.submitReport", hideNav: true },
  },
  {
    path: ":customer/reports/:id/submitted",
    component: new NavigationStrategy(() => import("./routes/report/submit-success")),
    data: { title: "pageTitle.reportSubmitted", hideNav: true },
  },
  {
    path: ":customer/reports/:id/print",
    component: new NavigationStrategy(() => import("./routes/report/print")),
    data: { title: "pageTitle.printReport", name: "print", public: true, hideNav: true },
  },
  {
    path: ":customer/statements/:id",
    component: new NavigationStrategy(() => import("./routes/application/evaluation")),
    data: { title: "pageTitle.statements", name: "statements", public: true, hideNav: true },
  },
  {
    path: ":customer/login",
    component: new NavigationStrategy(() => import("./routes/login/index")),
    data: { title: "pageTitle.login", name: "login", public: true },
  },
  {
    path: ":customer/login/bankid-form",
    component: new NavigationStrategy(() => import("./routes/login/bankid-form")),
    data: { title: "pageTitle.loginBankId", name: "bankidlogin", public: true },
  },
  {
    path: ":customer/login/start-session",
    component: new NavigationStrategy(() => import("./routes/login/start-session")),
    data: { title: "pageTitle.startSession", name: "start-session", public: true },
  },
  {
    path: ":customer/logged-out",
    component: new NavigationStrategy(() => import("./routes/login/logged-out")),
    data: { title: "pageTitle.loggedOut", name: "logged-out", public: true },
  },
  {
    path: ":customer/begin-password-reset",
    component: new NavigationStrategy(() => import("./routes/account/reset-password")),
    data: { title: "pageTitle.beginPasswordReset", public: true },
  },
  {
    path: ":customer/resetpassword",
    component: new NavigationStrategy(() => import("./routes/account/change-password")),
    data: { title: "pageTitle.resetPassword", public: true },
  },
  {
    path: ":customer/register-account",
    component: new NavigationStrategy(() => import("./routes/account/register")),
    data: { title: "pageTitle.registerAccount", public: true },
  },
  {
    path: ":customer/account/regbankid",
    component: new NavigationStrategy(() => import("./routes/account/regbankid")),
    data: { title: "pageTitle.registerBankId", name: "regbankid" },
  },
  {
    path: ":customer/account-registered",
    component: new NavigationStrategy(() => import("./routes/account/register-success")),
    data: { title: "pageTitle.accountRegistered", public: true },
  },
  {
    path: ":customer/account-registered-bankid",
    component: new NavigationStrategy(() => import("./routes/account/register-success-bankid")),
    data: { title: "pageTitle.accountRegistered", public: true },
  },
  {
    path: ":customer/account/activate",
    component: new NavigationStrategy(() => import("./routes/account/activate")),
    data: { title: "pageTitle.activateAccount", public: true },
  },
  {
    path: ":customer/privacy",
    component: new NavigationStrategy(() => import("./routes/account/privacy-policy")),
    data: { title: "pageTitle.privacy", public: true },
  },
  {
    path: ":customer/sign",
    id: "edit-form-sign",
    component: new NavigationStrategy(() => import("./routes/form-sign/index")),
    data: { title: "pageTitle.sign", name: "edit-form-sign", public: false, hideNav: true },
  },
];
